import { defaultLineHeight, THeaderFontSize } from '~ui/styleGuide/fontStyles'
import { TSingleSpace } from '~ui/styleGuide/spaces'

import { useLayoutCtx } from './contexts/LayoutProvider'

const mobileProductHeadingFontSize: THeaderFontSize = `l24`
const mobileProductHeadingPaddingTop: TSingleSpace = `large`
const mobileProductHeadingPaddingBottom: TSingleSpace = `smallMedium`

const mobileProductDetailImageSize = `100%`
const tabletProductDetailImageSize = `250px`
const desktopProductDetailImageSize = `350px`

const defaultHeadingLineHeight = defaultLineHeight

/**
 * Settings for the product detail layout.
 */
export const productDetailLayoutSettings = {
  defaultHeadingLineHeight,
  mobileProductHeadingFontSize,
  mobileProductHeadingPaddingTop,
  mobileProductHeadingPaddingBottom,
}

/**
 * Calculates and exports layout dimensions based on the viewport size.
 */
export const useProductDetailLayout = () => {
  const { isMobile, isTablet } = useLayoutCtx()

  // prettier-ignore
  const productDetailImageSize = isMobile
    ? mobileProductDetailImageSize
    : isTablet
      ? tabletProductDetailImageSize
      : desktopProductDetailImageSize

  return {
    productDetailImageSize,
  }
}
